import { render, staticRenderFns } from "./CricketLoadingPlaceholder.vue?vue&type=template&id=78c284c2&scoped=true&"
import script from "./CricketLoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./CricketLoadingPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./CricketLoadingPlaceholder.vue?vue&type=style&index=0&id=78c284c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c284c2",
  null
  
)

export default component.exports